.root {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
}

.nav {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 44px;
  border-radius: 9px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #475569;
  cursor: pointer;

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }
}

.field {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 44px;
  padding: 0 12px;
  border-radius: 9px;
  border: 1px solid #cbd5e1;
  background: #ffffff;
  cursor: pointer;
  font: inherit;
  text-align: left;
}

.titles {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.title {
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
}

.meta-row {
  display: flex;
  align-items: center;
  gap: 5px;
}

.dot {
  flex: none;
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background: #f59e0b;
}

.dot-tone-ok {
  background: #22c55e;
}

.meta {
  font-size: 10px;
  font-weight: 500;
  color: #b45309;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.meta-tone-ok {
  color: #64748b;
}

.chevron {
  flex: none;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
}

.overflow {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 44px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #64748b;
  cursor: pointer;

  &:disabled {
    cursor: default;
    opacity: 0.4;
  }
}
